/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Road_Dude_Prompt_CatInputs */

const en_road_dude_prompt_cat = /** @type {(inputs: Road_Dude_Prompt_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cat`)
};

const zh_road_dude_prompt_cat = /** @type {(inputs: Road_Dude_Prompt_CatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`猫咪`)
};

/**
* | output |
* | --- |
* | "Cat" |
*
* @param {Road_Dude_Prompt_CatInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const road_dude_prompt_cat = /** @type {((inputs?: Road_Dude_Prompt_CatInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Road_Dude_Prompt_CatInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_road_dude_prompt_cat(inputs)
	return zh_road_dude_prompt_cat(inputs)
});
export { road_dude_prompt_cat as "road_dude.prompt.cat" }